<template>
  <div>
    <script2>
      _tsRatingConfig = {
      tsid: 'X586585A7B0895E151A669F82C566BBEA',
      variant: 'skyscraper_horizontal',
      // valid values: 'vertical', 'skyscraper_horizontal', 'skyscraper_vertical', 'testimonial'
      theme: 'light',
      reviews: 10,
      // default = 10
      borderColor: '#d6d6d6',
      // optional - overrides the border color
      colorclassName: 'test',
      // optional - override the whole sticker style with your own css class
      introtext: 'What our customers say about us:',
      // optional - not used in skyscraper and testimoinal variants
      backgroundColor: '#ffdcof', fontColor: '#000000',
      // optional - overrides background and font colors - only used for testimonial variant
      richSnippets: 'off'
      };
      var scripts = document.getElementsByTagName('SCRIPT'),
      me = scripts[scripts.length - 1];
      var _ts = document.createElement('SCRIPT');
      _ts.type = 'text/javascript';
      _ts.async = true;
      _ts.charset = 'utf-8';
      _ts.src ='//widgets.trustedshops.com/reviews/tsSticker/tsSticker.js';
      me.parentNode.insertBefore(_ts, me);
      _tsRatingConfig.script = _ts;
    </script2>
    <div class="block">&nbsp;</div>
  </div>
</template>

<script>
export default {
  name: "ts-ratings"
};
</script>
